import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { isRedoEmailAddress } from "@redotech/redo-model/redo-domains";
import { createContext, memo, type ReactNode, useContext } from "react";

const INTELLIGENT_CYCLE_COUNTS_ACCOUNT_IDS = new Set<string>([
  // "3254951049724447060", // Manly Bands
]);

const IntelligentCycleCountsContext = createContext<boolean | undefined>(
  undefined,
);

export function useIntelligentCycleCountsFlag(): boolean {
  return useRequiredContext(IntelligentCycleCountsContext);
}

export const IntelligentCycleCountsFlagProvider = memo(
  function IntelligentCycleCountsFlagProvider({
    children,
  }: {
    children: ReactNode;
  }) {
    const user = useContext(UserContext);
    const team = useContext(TeamContext);
    const enabled =
      isRedoEmailAddress(user?.email) ||
      (team?.accountId != null &&
        INTELLIGENT_CYCLE_COUNTS_ACCOUNT_IDS.has(team.accountId));

    return (
      <IntelligentCycleCountsContext.Provider value={enabled}>
        {children}
      </IntelligentCycleCountsContext.Provider>
    );
  },
);
